import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FieldSortPipe } from "@chatForm/src/app/utils/field-sort.pipe";
import { FormFieldComponent } from "../components/form-field/form-field.component";
import { FormComponent } from "../components/form/form.component";
import { FormHeaderComponent } from "../components/form-header/form-header.component";
import { FormFooterComponent } from "../components/form-footer/form-footer.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { AppMaterialModule } from "../app-material.module";
import { RecaptchaModule } from "ng-recaptcha";
import { RecaptchaFormsModule } from "ng-recaptcha/forms";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppMaterialModule,
        RecaptchaModule.forRoot(),
        RecaptchaFormsModule,
     ],
    declarations: [
        FieldSortPipe,
		FormFieldComponent,
		FormComponent,
		FormHeaderComponent,
		FormFooterComponent
    ],
    exports: [
        FieldSortPipe,
		FormFieldComponent,
		FormComponent,
		FormHeaderComponent,
        FormFooterComponent
    ]
})
export class SharedModule{
    
}
